import IAddress from '@/models/interfaces/IAddress';
import Address from '@/models/Address';
import IAddressState from './interfaces/address-state.d';

export default class AddressState implements IAddressState {
    address: IAddress = new Address();
}
